
export default function includeNewRelic ( environment ) {
    if ( !environment ) {
        return; // for local dev, don't add newrelic
    }

    if( environment !== 'prod' ) {
        require( 'utils/startup/new-relic-non-prod.js' );
    } else {
        require( 'utils/startup/new-relic-prod.js' );
    }

}
